import memoize from "fast-memoize";
import fetch from "./fetch-trade-api";

const trims = memoize(
  async ({ yearId, makeId, modelId }) => {
    const resp = await fetch(
      `/v1/report/trims/year/${yearId}/make/${makeId}/model/${modelId}`
    );
    const trims = await resp.json();
    return new Map(Object.entries(trims));
  },
  {
    serializer: ({ yearId, makeId, modelId }) =>
      `${yearId}-${makeId}-${modelId}`
  }
);

export const label = async ({ yearId, makeId, modelId, trimId }) => {
  const map = await trims({ yearId, makeId, modelId });
  return map.get(trimId);
};

export default trims;
